import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

const AgeGate = () => {
  const { acceptAge } = useApp();
  const [age, setAge] = useState(false);
  const [liability, setLiability] = useState(false);
  const enabled = age && liability;

  return (
    <div className="min-h-screen w-full bg-[#F8F8F6] dark:bg-[#0F0F10] py-12 px-6">
      <div className="max-w-2xl mx-auto">
        <div className="flex justify-center mb-10">
          <div className="text-center">
            <div className="font-serif tracking-[0.3em] text-[22px] text-neutral-800 dark:text-neutral-100">HEALSGLOBE</div>
            <div className="tracking-[0.4em] text-[10px] mt-0.5 text-neutral-500">EXPORTS</div>
          </div>
        </div>

        <h2 className="tracking-[0.15em] text-[13px] text-neutral-500 dark:text-neutral-400 mb-3">AGE VERIFICATION</h2>
        <p className="text-[14px] leading-relaxed text-neutral-600 dark:text-neutral-300 mb-8">
          This website is intended for adults aged 21 years or older only. By entering this site you confirm that you are at least 21 years of age. If you are under 21, you must leave immediately. Access to this site by minors is strictly prohibited.
        </p>

        <div className="border-t border-neutral-200 dark:border-neutral-800 pt-8">
          <h2 className="tracking-[0.15em] text-[13px] text-neutral-500 dark:text-neutral-400 mb-3">LIABILITY DISCLAIMER</h2>
          <p className="text-[14px] leading-relaxed text-neutral-600 dark:text-neutral-300 mb-3">
            Healsglobe Exports is not a licensed pharmacy, medical provider, or healthcare professional. All products listed on this site are provided for research use only and are not intended to diagnose, treat, cure, or prevent any disease or medical condition.
          </p>
          <p className="text-[14px] text-neutral-600 dark:text-neutral-300 mb-2">By accessing this site and purchasing any products, you acknowledge and agree that:</p>
          <ul className="list-disc pl-6 text-[13.5px] text-neutral-600 dark:text-neutral-300 space-y-1.5 mb-4">
            <li>You are solely responsible for how you use any product purchased.</li>
            <li>You have consulted or will consult a qualified healthcare professional before use.</li>
            <li>Healsglobe Exports bears no liability for any adverse effects, injury, illness, or harm &mdash; direct or indirect &mdash; resulting from the use or misuse of any product.</li>
            <li>You assume all risks associated with purchase and use of any product.</li>
            <li>All sales are final. Healsglobe Exports is not responsible for any outcomes resulting from product use.</li>
          </ul>
          <p className="text-[13.5px] text-neutral-600 dark:text-neutral-300 mb-8">If you do not agree to these terms in full, you must exit this site immediately.</p>
        </div>

        <div className="border-t border-neutral-200 dark:border-neutral-800 pt-6 space-y-3">
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" checked={age} onChange={(e)=>setAge(e.target.checked)} className="w-4 h-4 rounded border-neutral-300 accent-neutral-800" />
            <span className="text-[14px] text-neutral-700 dark:text-neutral-200">I confirm I am 21 years of age or older.</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" checked={liability} onChange={(e)=>setLiability(e.target.checked)} className="w-4 h-4 rounded border-neutral-300 accent-neutral-800" />
            <span className="text-[14px] text-neutral-700 dark:text-neutral-200">I have read and agree to the liability disclaimer above.</span>
          </label>

          <button
            disabled={!enabled}
            onClick={() => enabled && acceptAge()}
            className={`w-full mt-6 rounded-full py-4 text-[15px] transition-colors ${enabled ? 'bg-[#2b2b2b] hover:bg-black text-white cursor-pointer' : 'bg-neutral-300 dark:bg-neutral-700 text-white cursor-not-allowed'}`}
          >
            Enter Site
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
